import React, { useState, useEffect } from 'react';
import { NavLink, Outlet } from 'react-router-dom';
import { getUser, getAllowedPaths, logout } from '../services/auth';
import './Layout.css';

const allNavItems = [
  { path: '/', icon: '📊', label: 'Dashboard' },
  { path: '/consumers', icon: '👥', label: 'Consumers' },
  { path: '/readings', icon: '🔧', label: 'Readings' },
  { path: '/billing', icon: '🧾', label: 'Billing' },
  { path: '/payments', icon: '💳', label: 'Payments' },
  { path: '/notices', icon: '⚠️', label: 'Notices' },
  { path: '/reports', icon: '📈', label: 'Reports' },
  { path: '/rates', icon: '💰', label: 'Rates' },
  { path: '/ledger', icon: '📋', label: 'Ledger' },
  { path: '/import', icon: '📥', label: 'Import' },
  { path: '/users', icon: '🔑', label: 'Users' },
];

export default function Layout() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [dark, setDark] = useState(() => localStorage.getItem('theme') === 'dark');
  const user = getUser();
  const allowed = getAllowedPaths();
  const navItems = allNavItems.filter(item => allowed.includes(item.path));

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', dark ? 'dark' : 'light');
    localStorage.setItem('theme', dark ? 'dark' : 'light');
  }, [dark]);

  return (
    <div className="layout">
      <aside className={`sidebar ${sidebarOpen ? 'open' : ''}`}>
        <div className="sidebar-header">
          <div className="sidebar-logo">💧</div>
          <div style={{ flex: 1 }}>
            <div className="sidebar-title">Loboc Municipal</div>
            <div className="sidebar-subtitle">Waterworks</div>
          </div>
          <button className="theme-toggle" onClick={() => setDark(!dark)} title={dark ? 'Switch to light mode' : 'Switch to dark mode'}>
            {dark ? '☀️' : '🌙'}
          </button>
        </div>
        <nav className="sidebar-nav">
          {navItems.map(item => (
            <NavLink
              key={item.path}
              to={item.path}
              end={item.path === '/'}
              className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}
              onClick={() => setSidebarOpen(false)}
            >
              <span className="nav-icon">{item.icon}</span>
              {item.label}
            </NavLink>
          ))}
        </nav>
        <div className="sidebar-footer">
          <div className="user-info">
            <div className="user-avatar">{user?.name?.[0] || 'U'}</div>
            <div className="user-details">
              <div className="user-name">{user?.name || 'User'}</div>
              <div className="user-role">{user?.role || ''}</div>
            </div>
            <button className="logout-btn" onClick={logout} title="Sign out">⏻</button>
          </div>
        </div>
      </aside>
      {sidebarOpen && <div className="sidebar-overlay" onClick={() => setSidebarOpen(false)} />}
      <div className="main-content">
        <header className="mobile-header">
          <button className="menu-btn" onClick={() => setSidebarOpen(!sidebarOpen)}>☰</button>
          <span style={{ flex: 1 }}>Loboc Waterworks</span>
          <button className="theme-toggle" onClick={() => setDark(!dark)}>
            {dark ? '☀️' : '🌙'}
          </button>
        </header>
        <div className="page-content">
          <Outlet />
        </div>
      </div>
    </div>
  );
}
